export const CHANGE_CARD = 'CHANGE_CARD';
export const TOGGLE_MENU = 'TOGGLE_MENU';
export const CHANGE_MENU_INDEX = 'CHANGE_MENU_INDEX';
